import { ViewModel } from '../view-model';
import { CONFIG } from '../../core/config';

export class InspectionPointType implements ViewModel {
  readonly friendlyTypeNameSingular: string = 'Inspection Point Type';
  readonly apiRoute: string = CONFIG.apiRoutes.inspectionPointType;

  inspectionPointTypeId: string;
  name: string;
  color: string;

  public json(): any {
    return this;
  }

  loadFromJson(data: any) {
    this.inspectionPointTypeId = data.inspectionPointTypeId;
    this.name = data.name;
    this.color = data.color;
  }
}
